export const environment = {
    production: false,
    apiUrl: 'https://devapi.factorkpi.com/api',
    webUrl: 'https://devapi.factorkpi.com',
    signalRHubUrl: 'https://devapi.factorkpi.com/kpi-hub',
    enableSignalR: true,
    companyLogoAttachmentId: '749019a2-29c9-4c8d-a5ab-9ae90459d792',
    certificateAttachmentId: '02b95555-3707-4245-a23e-1ce08b832a0c',
    reviewerId: 'da3bb85b-fb74-4730-a774-60635531ee3f',
    approverId: '1c8bbad2-f251-4270-841d-22fb42cd8936',
    manualDocumentTypeId: 'f5908842-4e89-460a-804c-df931bae534d',
    procedureDocumentTypeId: 'b5565e5d-f98a-4a39-9815-262594b4fac4',
    variableDocumentTypeId: '8b81f6eb-dc2f-425d-91d7-0f88c8882b39',
    variablePolicyTypeId: '8b81f6eb-dc2f-425d-91d7-0f88c8882b11',
    variableRetentionPeriodId: '88997803-4e84-4c09-99c1-7067de9c2795',
    variableRetentionActionId: '88997803-4e84-4c09-99c1-7067de9c2793',
    variableReviewFrequencyId: '88997803-4e84-4c09-99c1-7067de9c2796',
    variableSeverityTypeId: 'c39a79e4-60b9-4439-82e4-c38474c75db4',
    // Seeded by migration Seed_Employee_Category_VariableType (Grade A, B, C)
    variableEmployeeCategoryTypeId: '7c9e6b2a-4d1f-4a83-9b6e-2f0a8c5d3e10',
    variableSourceTypeId: '8b81f6eb-dc2f-425d-91d7-0f88c8882b40',
    variableFormFieldTypeId: 'c45146a4-7530-47b2-8d81-b8bf2d2e3bf3',
    planTypeId: '4a223176-8861-4558-b61c-a474cfc64dfd',
    visibilityTypeId: '8865807c-d833-414b-a16d-b35ca885747d',
    durationTypeId: '8de99b0e-f5f7-4b90-8406-5825146fee54',
    variableApprovalTypeId: '097b3487-74f6-4653-966d-ce56aabc8d95',
    variableSCMApprovalTypeId: '81e8dedf-8e83-41f7-a455-4665aba669dd',
    // Seeded by migration Seed_ShiftDayEntry_VariableType_Variables
    shiftStartDayEntryApprovalTypeId: 'c3e8a712-5f9d-4b2e-8c1a-7d6f5e4b3a01',
    shiftEndDayEntryApprovalTypeId: 'c3e8a712-5f9d-4b2e-8c1a-7d6f5e4b3a02',
    variableDispositionPlannerTypeId: '1fe55afc-3e88-491f-8744-8c2d3f93f85d',
    variableEvidenceReportTypeId: '8b81f6eb-dc2f-425d-91d7-0f88c8882b42',
    VariableCauseAnalysisReviewerId: 'd3c7a8c6-124a-4a2b-87e3-278967f2fd70',
    variableCarTypeId: '58496073-f7a3-4f87-8c65-ae1f66110542',
    variableTextFieldId: '4e4038ad-b575-4033-95a6-73686c8ad428',
    variableAttachmentFieldId: 'e160deb8-4c70-4319-8a3f-6ef6d2bb6a51',
    variableKpiMetricsTypeId: '859a09ad-e802-4a9b-a245-25a07e2353ee',
    thresholdAlertFrequencyTypeId: '6f100d9c-d246-43f0-a83b-8f4db3635102',
    meetingScheduleReminderTypeId: '97685f1f-9c73-4c13-ac8d-077c817d4609',
    // Google Maps JavaScript API key (Site/Project location picker). Restrict it to this app's domains in Google Cloud Console.
    googleMapsApiKey: 'AIzaSyCsfJvLcrG3D7OR4u24Gd5FwYMUUmumxLw'
};
